var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear_317_1294)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0713 24.4659C38.2223 21.9613 37.4577 19.4284 36.8125 16.856C39.2187 14.2152 48.5181 14.5661 51.1926 16.8148L48.7164 22.702C50.0481 20.9526 50.4957 20.2345 51.2901 19.2598C51.6233 19.4789 51.9389 19.7236 52.2341 19.9918C52.9385 20.6295 53.5675 21.3341 53.6947 22.3163C53.7772 22.9532 53.5952 23.6003 53.0284 24.2619L47.3473 30.8788C46.616 30.7589 45.9014 30.5834 45.208 30.3369C45.5302 29.5787 45.9187 28.7445 46.2409 27.9862L44.1726 30.2201C42.0179 29.7655 40.2851 30.0367 38.6704 30.8908L32.9089 23.9761C32.5666 23.5637 32.4109 23.1513 32.4122 22.7389C32.4176 21.0674 34.9064 19.6249 36.2146 19.0789L39.0713 24.4659ZM38.5864 50.351L39.3141 48.7118H42.0587C41.8854 48.1301 41.2052 47.8027 40.6355 47.8027H38.5864L39.3141 46.1634H47.1702L46.4425 47.8027H44.5448C44.7968 47.9959 45.0665 48.3938 45.1137 48.7118H47.1702L46.4425 50.351H44.9547C44.4744 51.5736 43.0097 52.4042 41.7606 52.5839L45.8886 56.8336H42.6249L38.944 52.795V51.2899H40.5734C41.1278 51.2899 41.8183 50.9004 41.9941 50.351H38.5864ZM46.4543 36.9588L45.3299 31.8163C50.146 32.712 57.8656 42.5089 60.36 46.9632C61.6332 49.2367 62.7483 51.7414 63.6613 54.5415C65.4801 61.318 63.7281 67.6574 56.3769 69.1341C51.771 70.0593 43.1811 70.1249 38.337 69.8742C33.1294 69.6047 25.0706 69.6131 22.9654 64.2662C19.5678 55.6358 25.7928 45.3544 31.4687 39.0616C32.2156 38.2336 32.9879 37.4619 33.7869 36.7496C35.8515 34.933 38.0778 32.7775 40.7354 31.8813L38.1685 36.6611L41.8967 31.7184H43.8613L46.4543 36.9588ZM33.5678 46.4368C36.3051 41.2947 42.6917 39.3452 47.8339 42.0824C52.9761 44.8195 54.9255 51.2062 52.1884 56.3485C49.4512 61.4906 43.0645 63.4401 37.9224 60.703C32.7801 57.9658 30.8307 51.5791 33.5678 46.4368Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_1294",
    x1: 128.912,
    y1: 76.2137,
    x2: 64.2309,
    y2: -57.8121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B947F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#106554"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentIcon);
export default __webpack_public_path__ + "static/media/investmentIcon.3a341d4dafb6dbf1e9498d700dd8ae47.svg";
export { ForwardRef as ReactComponent };